import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.013 22.536c.004-2.172.004-3.77-.002-4.72A3 3 0 0 0 44 14.993V11.3a5 5 0 0 0-4.805-4.996 386.623 386.623 0 0 0-15.015-.268c-5.482 0-10.606.091-15.371.274A5 5 0 0 0 4 11.306V15a3.003 3.003 0 0 0 1.99 2.817c-.007.95-.007 2.548-.003 4.72l.005 2.272.006 1.991L6 28.018c0 2.635.062 4.945.188 6.93a7 7 0 0 0 6.409 6.536c4.448.368 8.265.552 11.454.552 3.178 0 6.963-.183 11.355-.549a7 7 0 0 0 6.406-6.534c.125-1.987.188-4.298.188-6.935l.002-1.214.006-1.991.005-2.277ZM16 21v-3H7.988c-.005.954-.005 2.496-.001 4.533l.005 2.27.005 1.992L8 28.018c0 2.595.061 4.864.184 6.804a5 5 0 0 0 4.578 4.669c4.397.363 8.16.545 11.29.545 3.117 0 6.848-.18 11.188-.542a5 5 0 0 0 4.576-4.667c.122-1.942.184-4.212.184-6.81l.002-1.218.006-1.991.005-2.276c.004-2.036.004-3.579-.001-4.532H32v3a3 3 0 0 1-3 3H19a3 3 0 0 1-3-3ZM8.885 8.308A3 3 0 0 0 6 11.306v3.69a1 1 0 0 0 1.004.995c6.935-.027 11.486-.03 13.66-.008 1.148.011 5.58.011 6.71 0 2.175-.02 6.714-.018 13.626.009a1 1 0 0 0 1-1V11.3a3 3 0 0 0-2.883-2.997 384.636 384.636 0 0 0-14.937-.267c-5.458 0-10.556.09-15.295.272ZM18 21v-3h12v3a1 1 0 0 1-1 1H19a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Archive_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 40,
    height: 37
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.013 22.536c.004-2.172.004-3.77-.002-4.72A3 3 0 0 0 44 14.993V11.3a5 5 0 0 0-4.805-4.996 386.623 386.623 0 0 0-15.015-.268c-5.482 0-10.606.091-15.371.274A5 5 0 0 0 4 11.306V15a3.003 3.003 0 0 0 1.99 2.817c-.007.95-.007 2.548-.003 4.72l.005 2.272.006 1.991L6 28.018c0 2.635.062 4.945.188 6.93a7 7 0 0 0 6.409 6.536c4.448.368 8.265.552 11.454.552 3.178 0 6.963-.183 11.355-.549a7 7 0 0 0 6.406-6.534c.125-1.987.188-4.298.188-6.935l.002-1.214.006-1.991.005-2.277ZM16 21v-3H7.988c-.005.954-.005 2.496-.001 4.533l.005 2.27.005 1.992L8 28.018c0 2.595.061 4.864.184 6.804a5 5 0 0 0 4.578 4.669c4.397.363 8.16.545 11.29.545 3.117 0 6.848-.18 11.188-.542a5 5 0 0 0 4.576-4.667c.122-1.942.184-4.212.184-6.81l.002-1.218.006-1.991.005-2.276c.004-2.036.004-3.579-.001-4.532H32v3a3 3 0 0 1-3 3H19a3 3 0 0 1-3-3ZM8.885 8.308A3 3 0 0 0 6 11.306v3.69a1 1 0 0 0 1.004.995c6.935-.027 11.486-.03 13.66-.008 1.148.011 5.58.011 6.71 0 2.175-.02 6.714-.018 13.626.009a1 1 0 0 0 1-1V11.3a3 3 0 0 0-2.883-2.997 384.636 384.636 0 0 0-14.937-.267c-5.458 0-10.556.09-15.295.272ZM18 21v-3h12v3a1 1 0 0 1-1 1H19a1 1 0 0 1-1-1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Archive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h48v48H0z"
  })));
};

var SvgArchive = styled(SvgComponent).withConfig({
  displayName: "Archive__SvgArchive",
  componentId: "sc-8dmkor-0"
})(["", " ", ""], size, color);
export default SvgArchive;